import { compose, createStore, applyMiddleware } from 'redux';
import createHistory from 'history/createBrowserHistory';
import thunk from 'redux-thunk';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import devToolsEnhancer from 'remote-redux-devtools';
import { createLogicMiddleware } from 'redux-logic';
import rootLogics from './logics';
import reducer from './reducer';
export var history = createHistory();
var deps = {};
var logicMiddleware = createLogicMiddleware(rootLogics, deps);
var middlewares = [routerMiddleware(history), thunk, logicMiddleware];
var enhancers = [applyMiddleware.apply(void 0, middlewares), devToolsEnhancer()];
var prodEnhancers = [applyMiddleware.apply(void 0, middlewares)];
var store = createStore(connectRouter(history)(reducer), process.env.NODE_ENV === 'development' ? compose.apply(void 0, enhancers) : compose.apply(void 0, prodEnhancers));
export default store;